import { API_URL } from './client';
import { SocketClient } from '../services/SocketClient';
import { OnlineStaffUser } from '../types';
import { getAccessToken } from './accessToken';

const PRESENCE_HEARTBEAT_INTERVAL_MS = 5_000;

export interface SocketEvent {
  type?: string;
  chat_id?: string;
  incoming_message_id?: string;
  users?: OnlineStaffUser[];
}

export const socketEventChatToRefresh = (
  event: SocketEvent,
  selectedChatId: string | null,
): string | null => {
  if (!selectedChatId) return null;
  if (event.type === 'chat_updated' && event.chat_id === selectedChatId)
    return selectedChatId;
  return null;
};

export const connectSocket = (onUpdate: (event: SocketEvent) => void): (() => void) => {
  const token = getAccessToken();
  const base = API_URL.replace(/^http/, 'ws').replace(/\/$/, '');
  const client = new SocketClient<SocketEvent, string>({
    url: () => `${base}/ws`,
    protocols: (accessToken) => accessToken ? ['bearer', accessToken] : [],
    reconnectDelayMs: 1500,
    onOpen: () => {
      client.send({ type: 'presence_heartbeat' });
    },
    onParseError: () => onUpdate({})
  });
  const unsubscribe = client.subscribe(onUpdate);
  client.connect(token);
  const heartbeatTimer = window.setInterval(() => {
    client.send({ type: 'presence_heartbeat' });
  }, PRESENCE_HEARTBEAT_INTERVAL_MS);
  return () => {
    window.clearInterval(heartbeatTimer);
    unsubscribe();
    client.disconnect();
  };
};
